import api from './api';
import { Package, ApiResponse, PaginatedResponse } from '../types';

class PackageService {
  async getPackages(page = 1, limit = 10, filters?: Record<string, any>): Promise<PaginatedResponse<Package>> {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString()
    });
    
    if (filters) {
      Object.keys(filters).forEach(key => {
        if (filters[key] !== undefined && filters[key] !== null) {
          params.append(key, filters[key].toString());
        }
      });
    }
    
    const response = await api.get<PaginatedResponse<Package>>(`/packages?${params.toString()}`);
    return response.data;
  }

  async getAllActivePackages(spopId?: string): Promise<Package[]> {
    const url = spopId ? `/packages/active?spop_id=${spopId}` : '/packages/active';
    const response = await api.get<ApiResponse<Package[]>>(url);
    return response.data.data;
  }

  async getPackage(id: string): Promise<Package> {
    const response = await api.get<ApiResponse<Package>>(`/packages/${id}`);
    return response.data.data;
  }

  async createPackage(packageData: Omit<Package, 'id' | 'created_at' | 'updated_at'>): Promise<Package> {
    const response = await api.post<ApiResponse<Package>>('/packages', packageData);
    return response.data.data;
  }

  async updatePackage(id: string, packageData: Partial<Package>): Promise<Package> {
    const response = await api.put<ApiResponse<Package>>(`/packages/${id}`, packageData);
    return response.data.data;
  }

  async deletePackage(id: string): Promise<void> {
    await api.delete(`/packages/${id}`);
  }

  async toggleStatus(id: string, status: 'active' | 'inactive'): Promise<void> {
    await api.patch(`/packages/${id}/status`, { status });
  }
}

const packageService = new PackageService();
export default packageService;
